import { Component, Inject } from '@angular/core';
import { Recipient } from '../../../interfaces/recipient';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dismiss-acceptable-bloodtypes-warning-dialog',
  imports: [MatDialogModule, MatDialogContent, MatButtonModule, MatFormFieldModule, MatInputModule, CommonModule, FormsModule],
  templateUrl: './dismiss-acceptable-bloodtypes-warning-dialog.component.html',
  styleUrl: './dismiss-acceptable-bloodtypes-warning-dialog.component.scss'
})
export class DismissAcceptableBloodtypesWarningDialogComponent {
  constructor(
    private readonly ref: MatDialogRef<DismissAcceptableBloodtypesWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { recipient: Recipient }
  ) {
    this.recipient = data.recipient;
  }

  recipient!: Recipient;
  dismissalReason: string = '';

  isFormValid(): boolean {
    return this.dismissalReason.trim() !== '';
  }

  cancel(): void {
    this.ref.close(false);
  }

  dismiss(): void {
    if (!this.isFormValid()) return;
    this.ref.close({ confirmed: true, reason: this.dismissalReason });
  }
}
